import React from "react";
import NavBar from "./Components/NavBar/NavBar";
import './App.css';
import Banner from "./Components/Banner/Banner";
import RowPost from "./Components/RowPoster/RowPost";

import RowImgs from "./RowImgs";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
     <RowImgs/>

    </div>
  );
}

export default App;
